import { useMutation } from "react-query";
import { MERCHANT_API_PATH } from "src/confs/APIConfig";
import type { MVNType } from "src/numbers/objects/MVNType";
import { useApiPost } from "src/shared/actions/FetchActions";

export interface AssignNumberParams {
  providerId?: number;
  mobileVirtualNumber?: string;
  mvnType?: MVNType;
}

export const useAssignNumber = (countryCode: string) => {
  const apiPost = useApiPost();
  return useMutation(async (assignNumberProps?: AssignNumberParams) => {
    const { data } = await apiPost<{ mobileVirtualNumber: string }>(
      `${MERCHANT_API_PATH}/action/_number.assign`,
      { countryCode, ...assignNumberProps },
    );
    return data;
  });
};
